<h2 class="mb-4 font-semibold leading-none text-gray-700">DTC(s) assigned</h2>
<div #scrollContainer class="relative overflow-x-hidden max-h-[calc(100vh-27rem)] overflow-y-auto mt-2">
  <ul class="max-w-md space-y-1 text-gray-500 list-inside">
    @for (dtc of dtcs; let i = $index; track $index) {
      <li [ngClass]="{ 'mt-2': i === 0 }" class="flex items-center">
        <svg
          class="w-3.5 h-3.5 me-2 text-amazone-green shrink-0"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"
          />
        </svg>
        <a (click)="navigateToDtc(dtc.id, dtc.displayId)" class="cursor-pointer">
          <p>
            <strong>{{ dtc.displayId }}</strong> -
            {{ commonUtils.truncateString(dtc.implementationHint, 50 - (dtc.displayId?.length || 0)) }}
          </p>
        </a>
        @if (dtc.implementationHint && dtc.displayId && `${dtc.displayId} - ${dtc.implementationHint}`.length > 50) {
          <div
            class="absolute z-10 inline-block px-3 py-2 text-sm font-medium text-gray-800 transition-opacity duration-300 bg-gray-200 rounded-lg shadow-xs tooltip opacity-0 hover:opacity-100 translate-x-12"
          >
            {{ dtc.implementationHint }}
          </div>
        }
      </li>
    } @empty {
      <li class="flex items-center">
        <span>No DTCs assigned</span>
      </li>
    }
  </ul>
</div>
